const lemon = [
	{
		top: 'Липкий рис с манго вместе с Aqua Minerale со вкусом лимона',
		bottom: 'Яркий экзотический вкус манго и сладкого риса отлично дополняется свежестью цитрусовых',
		img: '1.png',
		url: 'https://eda.ru/recepty/zavtraki/lipkiy-ris-s-mango-92512?utm_source=karta_vkusov',
	},
	{
		top: 'Филе лосося в маринаде с наршарабом вместе с Aqua Minerale со вкусом лимона',
		bottom: 'Цитрусовые и красная рыба всегда составляют гармоничную пару, а сладость соуса наршараб подчеркивается свежей горчинкой',
		img: '2.png',
		url: 'https://eda.ru/recepty/osnovnye-blyuda/file-lososja-v-marinade-s-narsharabom-35304?utm_source=karta_vkusov',
	},
	{
		top: 'Цукини с пастой мисо и креветками вместе с Aqua Minerale со вкусом лимона',
		bottom: 'Заправка на основе мисо и нежное мясо креветок великолепно подчеркивается лимонным вкусом',
		img: '3.png',
		url: 'https://eda.ru/recepty/osnovnye-blyuda/cukini-s-pastoj-miso-krevetkami-22033?utm_source=karta_vkusov',
	},
	{
		top: 'Ахобланко вместе с Aqua Minerale со вкусом лимона',
		bottom: 'Легкий миндальный суп с хересной пикантной ноткой изысканно дополняют свежие цитрусовые',
		img: '4.png',
		url: 'https://eda.ru/recepty/supy/ahoblanko-93265?utm_source=karta_vkusov',
	},
	{
		top: 'Гравлакс вместе с Aqua Minerale со вкусом лимона',
		bottom: 'Солоновато-сладкий лосось и пикантная горчинка лимона выступают в качестве изысканного начала трапезы',
		img: '5.png',
		url: 'https://eda.ru/recepty/zakuski/gravlaks-91896?utm_source=karta_vkusov',
	},
	{
		top: 'Оливье с раками и желе вместе с Aqua Minerale со вкусом лимона',
		bottom: 'К этому изысканному рецепту нежного оливье с раковыми шейками прекрасно подойдет цитрусовая свежесть и легкая горчинка',
		img: '6.png',
		url: 'https://eda.ru/recepty/osnovnye-blyuda/olive-s-rakami-i-zhele-91558?utm_source=karta_vkusov',
	},
	{
		top: 'Массаман-карри классический вместе с Aqua Minerale со вкусом лимона',
		bottom: 'Обилие специй, острота перца и пикантность имбиря дополняются свежестью лимонного сока',
		img: '7.png',
		url: 'https://eda.ru/recepty/osnovnye-blyuda/massaman-karri-klassicheskiy-114780?utm_source=karta_vkusov',
	},
	{
		top: 'Сальтимбокка вместе с Aqua Minerale со вкусом лимона',
		bottom: 'Классическое итальянское блюдо, сочное и плотное, станет ярче благодаря яркой лимонной кислотности',
		img: '8.png',
		url: 'https://eda.ru/recepty/osnovnye-blyuda/saltimbokka-49597?utm_source=karta_vkusov',
	},
	{
		top: 'Пирог из ризотто с куриной грудкой вместе с Aqua Minerale со вкусом лимона',
		bottom: 'Нежное сливочное ризотто с курицей великолепно оттенит лимонная кислинка',
		img: '9.png',
		url: 'https://eda.ru/recepty/osnovnye-blyuda/pirog-iz-rizotto-s-kurinoj-grudkoj-30396?utm_source=karta_vkusov',
	},
	{
		top: 'Спагетти с лимонным песто вместе с Aqua Minerale со вкусом лимона',
		bottom: 'Песто с нотками цитрусовых идеально дополнит свежесть лимонного сока',
		img: '10.png',
		url: 'https://eda.ru/recepty/pasta-picca/spagetti-s-limonnim-pesto-30218?utm_source=karta_vkusov',
	},
]

const lime = [
	{
		top: 'Рамен вместе с Aqua Minerale со вкусом мята-лайм',
		bottom: 'Рамен с насыщенным вкусом свиной грудинки требует свежего вкуса мяты и лайма',
		img: '1.png',
		url: 'https://eda.ru/recepty/supy/ramen-114793?utm_source=karta_vkusov',
	},
	{
		top: 'Салат из перцев и жареного халуми вместе с Aqua Minerale со вкусом мята-лайм',
		bottom: 'Яркая сладость перцев и сливочный вкус сыра гармонично дополняются вкусом мяты и лайма',
		img: '2.png',
		url: 'https://eda.ru/recepty/salaty/salat-iz-percev-zharenogo-halumi-24244?utm_source=karta_vkusov',
	},
	{
		top: 'Чечевичный суп с мятой вместе с Aqua Minerale со вкусом мята-лайм',
		bottom: 'Нежный и ароматный суп из чечевицы изящно подчеркнет мятная прохлада и свежесть цитрусовых',
		img: '3.png',
		url: 'https://eda.ru/recepty/supy/chechevichnij-sup-s-mjatoj-27007?utm_source=karta_vkusov',
	},
	{
		top: 'Фисташковый мусс с авокадо вместе с Aqua Minerale со вкусом мята-лайм',
		bottom: 'Ароматный фисташковый мусс с авокадо дополняется нотками свежей мяты и лайма',
		img: '4.png',
		url: 'https://eda.ru/recepty/vypechka-deserty/fistashkovij-muss-s-avokado-31131?utm_source=karta_vkusov',
	},
	{
		top: 'Настоящий греческий салат вместе с Aqua Minerale со вкусом мята-лайм',
		bottom: 'Традиционный греческий салат великолепно сочетается с ярким вкусом лайма, а мята деликатно оттеняет яркий вкус сыра',
		img: '5.png',
		url: 'https://eda.ru/recepty/salaty/nastojaschij-grecheskij-salat-30893?utm_source=karta_vkusov',
	},
	{
		top: 'Киш лорен вместе с Aqua Minerale со вкусом мята-лайм',
		bottom: 'Лотарингский пирог с пикантным ароматом сыра грюйер отлично сочетается с мятной прохладой и кислотностью лайма',
		img: '6.png',
		url: 'https://eda.ru/recepty/vypechka-deserty/francuzskiy-kish-loren-92496?utm_source=karta_vkusov',
	},
	{
		top: 'Лохикейтто вместе с Aqua Minerale со вкусом мята-лайм',
		bottom: 'Сливочная основа, пряности и красная рыба гармонично сочетаются с мятной прохладой',
		img: '7.png',
		url: 'https://eda.ru/recepty/supy/lohikeytto-92772?utm_source=karta_vkusov',
	},
	{
		top: 'Огуречная райта вместе с Aqua Minerale со вкусом мята-лайм',
		bottom: 'Холодная освежающая райта с выраженными огуречными оттенками изысканно дополняется сочностью лайма и свежим мятным вкусом',
		img: '8.png',
		url: 'https://eda.ru/recepty/sousy-marinady/ogurechnaya-rayta-92533?utm_source=karta_vkusov',
	},
	{
		top: 'Сопа-де-лима вместе с Aqua Minerale со вкусом мята-лайм',
		bottom: 'Мексиканский пряный суп с кислинкой цитрусовых идеально подчеркнет вкус мяты и лайма',
		img: '9.png',
		url: 'https://eda.ru/recepty/supy/sopa-de-lima-93327?utm_source=karta_vkusov',
	},
	{
		top: 'Фаттуш вместе с Aqua Minerale со вкусом мята-лайм',
		bottom: 'Летний свежий ближневосточный салат с хрустящей питой прекрасно дополнит свежесть лимона',
		img: '10.png',
		url: 'https://eda.ru/recepty/salaty/fattush-50259?utm_source=karta_vkusov',
	},
	{
		top: 'Спринг-роллы вместе с Aqua Minerale со вкусом мята-лайм',
		bottom: 'Нежный вкус спринг-роллов с креветками составит прекрасную пару как кислинке цитрусовых, так и мятной свежести',
		img: '11.png',
		url: 'https://eda.ru/recepty/sendvichi/spring-rolly-114563?utm_source=karta_vkusov',
	},
]

const cherry = [
	{
		top: 'Азиатский салат из говядины с кунжутной заправкой вместе с Aqua Minerale со вкусом черешни',
		bottom: 'Свежий легкий салат с азиатскими пряными акцентами отлично сочетается с сочным вкусом черешни',
		img: '1.png',
		url: 'https://eda.ru/recepty/salaty/aziatskij-salat-iz-govjadini-s-kunzhutnoj-zapravkoj-18596?utm_source=karta_vkusov',
	},
	{
		top: 'Тост «Скаген» с креветками вместе с Aqua Minerale со вкусом черешни',
		bottom: 'К этой изысканной скандинавской закуске идеальным дополнением станет сочная фруктовость черешни',
		img: '2.png',
		url: 'https://eda.ru/recepty/zakuski/tost-skagen-s-krevetkami-80436?utm_source=karta_vkusov',
	},
	{
		top: 'Перепелка с чечевицей вместе с Aqua Minerale со вкусом черешни',
		bottom: 'Деликатность перепелки в сочетании с чечевицей и красным соусом прекрасно дополняется яркими ягодными оттенками черешни',
		img: '3.png',
		url: 'https://eda.ru/recepty/osnovnye-blyuda/perepelka-s-chechevicej-30391?utm_source=karta_vkusov',
	},
	{
		top: 'Жареный сыр с чатни из черешни вместе с Aqua Minerale со вкусом черешни',
		bottom: 'Ноты черешни станут гармоничным продолжением вкуса чатни с жареным сыром',
		img: '4.png',
		url: 'https://eda.ru/recepty/zakuski/zharenyy-syr-s-chatni-iz-chereshni-125423?utm_source=karta_vkusov',
	},
	{
		top: 'Салат с киноа вместе с Aqua Minerale со вкусом черешни',
		bottom: 'Сочетание легкого салата из киноа с пикантной кислинкой и маслянистостью авокадо великолепно дополнится ягодной сочностью черешни',
		img: '5.png',
		url: 'https://eda.ru/recepty/salaty/salat-s-kinoa-52669?utm_source=karta_vkusov',
	},
	{
		top: 'Гребешки с артишоками и соусом унаги вместе с Aqua Minerale со вкусом черешни',
		bottom: 'Сладость черешни мягко подчеркнет соус унаги и нежную текстуру гребешка',
		img: '6.png',
		url: 'https://eda.ru/recepty/zakuski/grebeshki-s-artishokami-sousom-unagi-30997?utm_source=karta_vkusov',
	},
	{
		top: 'Паста алла норма вместе с Aqua Minerale со вкусом черешни',
		bottom: 'Классическую пасту с томатами, чесноком и рикоттой идеально дополнит вкус спелых ягод черешни',
		img: '7.png',
		url: 'https://eda.ru/recepty/pasta-picca/pasta-alla-norma-125407?utm_source=karta_vkusov',
	},
	// {
	// 	top: 'Рамен вместе с Aqua Minerale со вкусом черешни',
	// 	bottom: 'Насыщенные вкусы рамена с грудинкой великолепно сочетаются с ягодным вкусом черешни',
	// 	img: '8.png',
	// 	url: 'https://eda.ru/recepty/supy/ramen-114793?utm_source=karta_vkusov',
	// },
	{
		top: 'Паэлья с кроликом вместе с Aqua Minerale со вкусом черешни',
		bottom: 'Нежное мясо кролика в паэлье отлично гармонирует со сладостью черешни',
		img: '9.png',
		url: 'https://eda.ru/recepty/osnovnye-blyuda/paelya-s-krolikom-125568?utm_source=karta_vkusov',
	},
]

const apple = [
	{
		top: 'Спагетти алла путтанеска вместе с Aqua Minerale со вкусом яблока',
		bottom: 'Яркий вкус анчоусов и пармезана гармонично сочетается с яблочной сладостью',
		img: '1.png',
		url: 'https://eda.ru/recepty/osnovnye-blyuda/spagetti-alla-puttaneska-28035?utm_source=karta_vkusov',
	},
	{
		top: 'Курица гунбао вместе с Aqua Minerale со вкусом яблока',
		bottom: 'Легкая острота и нежное мясо цыпленка элегантно сочетаются со сладостью спелого яблока',
		img: '2.png',
		url: 'https://eda.ru/recepty/osnovnye-blyuda/kurica-gunbao-92734?utm_source=karta_vkusov',
	},
	{
		top: 'Сугудай из красной рыбы вместе с Aqua Minerale со вкусом яблока',
		bottom: 'Вкус красной рыбы в насыщенном кислотном маринаде отлично оттеняет яблочная сладость',
		img: '3.png',
		url: 'https://eda.ru/recepty/zakuski/suguday-iz-krasnoy-ryby-126552?utm_source=karta_vkusov',
	},
	// {
	// 	top: 'Селедка под шубой с яблоком вместе с Aqua Minerale со вкусом яблока',
	// 	bottom: 'Классический русский салат с целой палитрой интенсивных вкусов сгладится за счет сладости яблока',
	// 	img: '4.png',
	// 	url: 'https://eda.ru/recepty/salaty/seledka-pod-shuboy-s-yablokom-91559?utm_source=karta_vkusov',
	// },
	{
		top: 'Говядина «Веллингтон» с зеленой фасолью вместе с Aqua Minerale со вкусом яблока',
		bottom: 'Насыщенный сладковатый мясной соус и деликатный вкус говяжьей вырезки выигрышно подчеркнет сочный вкус яблока',
		img: '5.png',
		url: 'https://eda.ru/recepty/osnovnye-blyuda/govyadina-vellington-37189?utm_source=karta_vkusov',
	},
	{
		top: 'Золотая форель с брюссельской капустой вместе с Aqua Minerale со вкусом яблока',
		bottom: 'Деликатный вкус форели и хрустящая брюссельская капуста беспроигрышно сочетаются со сладостью яблок',
		img: '6.png',
		url: 'https://eda.ru/recepty/osnovnye-blyuda/zolotaja-forel-s-brjusselskoj-kapustoj-30403?utm_source=karta_vkusov',
	},
	{
		top: 'Телячья вырезка с пюре из айвы и брусничным соусом вместе с Aqua Minerale со вкусом яблока',
		bottom: 'Соус из брусники и сочную телятину прекрасно подчеркнет вкус красных яблок',
		img: '7.png',
		url: 'https://eda.ru/recepty/osnovnye-blyuda/telyachya-vyrezka-s-pyure-iz-ayvy-i-brusnichnym-sousom-126296?utm_source=karta_vkusov',
	},
	{
		top: 'Классический ростбиф вместе с Aqua Minerale со вкусом яблока',
		bottom: 'Сочный ростбиф прекрасно сочетается со вкусом спелых яблок',
		img: '8.png',
		url: 'https://eda.ru/recepty/osnovnye-blyuda/klassicheskiy-rostbif-58546?utm_source=karta_vkusov',
	},
	{
		top: 'Спагетти карбонара вместе с Aqua Minerale со вкусом яблока',
		bottom: 'Сливочная карбонара с беконом отлично дополняется кислым яблочным вкусом',
		img: '9.png',
		url: 'https://eda.ru/recepty/pasta-picca/spagetti-karbonara-81236?utm_source=karta_vkusov',
	},
	{
		top: 'Томатная запеканка с яйцами и луком вместе с Aqua Minerale со вкусом яблока',
		bottom: 'Легкую томатную запеканку с яйцом прекрасно подчеркнет вкус спелых красных яблок',
		img: '10.png',
		url: 'https://eda.ru/recepty/osnovnye-blyuda/tomatnaja-zapekanka-s-jajcami-lukom-26989?utm_source=karta_vkusov',
	},
]




export default {
	lemon,
	lime,
	cherry,
	apple,
}